import * as React from "react";

import {Box, Container, FormControlLabel, Radio, Typography} from "@mui/material";
import { H2, H4, H5 } from "components/CustomTypography";
import TextFieldComponent from "components/TextField";
import ButtonComponent from "components/Button";
import CheckboxComponent from "components/Checkbox";
import PropTypes from "prop-types";
import {
  schema, getTextfieldData1, getTextfieldData2, getButtonData, getCheckboxData1, getCheckboxData2, getCheckboxSizeLetters, getCheckboxSizeNumbers,
} from "./helper";
import { CURRENCY } from "config/constants";
import {useState} from "react";

const SellerProductEntryForm = ({
  setState, product, updateProductSettingClicked, cancelEdit, symbol, shop
}) => {
  const {
    name, id, price, minqty, is_price_visible, is_price_onunlock, is_listing_active, in_stock, size, product_id, listing_id
  } = product || {};

  const [participants, setParticipants] = useState(size);
  const [currentPriceVisible, setCurrentPriceVisible] = useState(is_price_visible);
  const [isPriceOnunlock, setIsPriceOnunlock] = useState(is_price_onunlock);

  const XS = size.includes("XS");
  const S = size.includes("S");
  const M = size.includes("M");
  const L = size.includes("L");
  const XL = size.includes("XL");
  const XXL = size.includes("XXL");
  const XXXL = size.includes("XXXL");
  const XXXXL = size.includes("XXXXL");
  const SIZE_24 = size.includes("24");
  const SIZE_26 = size.includes("26");
  const SIZE_28 = size.includes("28");
  const SIZE_30 = size.includes("30");
  const SIZE_32 = size.includes("32");
  const SIZE_34 = size.includes("34");
  const SIZE_36 = size.includes("36");
  const SIZE_38 = size.includes("38");
  const SIZE_40 = size.includes("40");
  const SIZE_42 = size.includes("42");

  const [blur, setblur] = React.useState({
    price: false,
    minqty: false,
    is_price_visible: false,
    is_price_onunlock: false,
    is_listing_active: false,
    in_stock: false,
    size: false,
    XS: false,
    S: false,
    M: false,
    L: false,
    XL: false,
    XXL: false,
    XXXL: false,
    XXXXL: false,
    "24": false,
    "26": false,
    "28": false,
    "30": false,
    "32": false,
    "34": false,
    "36": false,
    "38": false,
    "40": false,
    "42": false,
  });

  const onFinish = () => {
    updateProductSettingClicked({
      price, minqty, is_price_visible: currentPriceVisible, is_price_onunlock: isPriceOnunlock, is_listing_active, in_stock, size: participants
    }, listing_id);
  };

  const handleTextFieldChangePrice = (event, field) => {
    const newPrice = event.target.value;
    setState(newPrice, field);
    
    // Automatically enable "Show price on site" if a valid price is set
    const priceValue = parseFloat(newPrice);
    if (!isNaN(priceValue) && priceValue > 0 && !currentPriceVisible) {
      setCurrentPriceVisible(true);
    }
    
    setblur({ ...blur, [field]: true });
  };

  const handlePriceFocus = (event, field) => {
    // Clear the field if the current value is 0
    if (price === 0 || price === "0" || price === 0.0 || price === "0.0" || price === "0.00") {
      setState("", field);
    }
  };

  const handleTextFieldChange = (event, field) => {
    setState(event.target.value, field);
    setblur({ ...blur, [field]: true });
  };

  const handleCheckBoxChange = (event, field) => {
    const isChecked = event.target.checked;

    if (field === "is_price_visible") {
      setCurrentPriceVisible(isChecked);

      // if price not visable, disable on lock as well
      if (!isChecked) {
        setIsPriceOnunlock(isChecked);
      }
    }

    if (field === "is_price_onunlock") {
      setIsPriceOnunlock(isChecked); // Update local state
    }
    setState(isChecked, field);
    setblur({ ...blur, [field]: true });
  };

  const handleCheckBoxListChange = (event, field) => {

    setblur({ ...blur, [field]: true });

    const value = field;
    let newlist = participants;

    newlist = newlist.includes(value) ? newlist.filter((f) => f !== value) : [...newlist, value];
    setParticipants(newlist);
    setState(newlist, "size");
  };

  const hasError = () => {
    try {
      return !schema.validateSync(product);
    } catch (err) {
      return true;
    }
  };

  const handleBlur = (field) => {
    setblur({ ...blur, [field]: true });
  };

  const isTouched = () => (blur.price || blur.minqty || blur.is_price_visible || blur.is_price_onunlock || blur.is_listing_active || blur.in_stock ||
      blur.XS || blur.S || blur.M || blur.L || blur.XL || blur.XXL || blur.XXXL || blur.XXXXL || blur["24"] || blur["26"] || blur["28"] || blur["30"] || blur["32"] || blur["34"] || blur["36"] || blur["38"] || blur["40"] || blur["42"]);

  const getError = (field) => {
    if (blur[field] && hasError()) {
      try {
        schema.validateSyncAt(field, product);
      } catch (err) {
        return err.message;
      }
    }
    return null;
  };

  return (
    <Container>
      <Box>
        {getTextfieldData1(price).map((element) => (
          <Box className="textfield" m={2}>
            <TextFieldComponent
              required
              label={element.label + " (" + symbol + ")"}
              value={element.value}
              error={!!getError(element.onChangeField)}
              helperText={getError(element.onChangeField)}
              onChange={(event) => handleTextFieldChangePrice(event, element.onChangeField)}
              onFocus={(event) => handlePriceFocus(event, element.onChangeField)}
            />
          </Box>
        ))}

        {shop && shop.length > 0 && shop[0].is_wholesale && getTextfieldData2(minqty).map((element) => (
            <Box className="textfield" m={2}>
              <TextFieldComponent
                  required
                  label={element.label}
                  value={element.value}
                  error={!!getError(element.onChangeField)}
                  helperText={getError(element.onChangeField)}
                  onChange={(event) => handleTextFieldChange(event, element.onChangeField)}
              />
            </Box>
        ))}

        <Box className="textfield"
             display="flex"
             flexDirection="row"
             alignItems="left">
        {getCheckboxData1(currentPriceVisible, isPriceOnunlock)
            .filter(element => !(currentPriceVisible === false && element.onChangeField === 'is_price_onunlock'))
            .map((element) => (
          <Box className="textfield"
               display="flex"
               m={2}>
                <CheckboxComponent
                    required
                    label={element.label}
                    value={element.value}
                    onChange={(event) => handleCheckBoxChange(event, element.onChangeField)}
                />
          </Box>
          ))}
        </Box>

        {getCheckboxData2(is_listing_active, in_stock)
            .map((element) => (
                <Box className="textfield" m={2}>
                      <CheckboxComponent
                          required
                          label={element.label}
                          value={element.value}
                          onChange={(event) => handleCheckBoxChange(event, element.onChangeField)}
                      />
                </Box>
            ))}

        <H4>Size available:</H4>
        <H5>(Do not select for 1 size items)</H5>
        <Box display="flex" flexWrap="wrap">
        {getCheckboxSizeLetters(XS, S, M, L, XL, XXL, XXXL, XXXXL).map((element) => (
            <Box m={2} key={element.onChangeField}>
              <CheckboxComponent
                  required
                  label={element.label}
                  value={element.value}
                  onChange={(event) => handleCheckBoxListChange(event, element.onChangeField)}
              />
            </Box>
        ))}
        </Box>
        <Box display="flex" flexWrap="wrap">
        {getCheckboxSizeNumbers(SIZE_24, SIZE_26, SIZE_28, SIZE_30, SIZE_32, SIZE_34, SIZE_36, SIZE_38, SIZE_40, SIZE_42).map((element) => (
            <Box m={2} key={element.onChangeField}>
              <CheckboxComponent
                  required
                  label={element.label}
                  value={element.value}
                  onChange={(event) => handleCheckBoxListChange(event, element.onChangeField)}
              />
            </Box>
        ))}
        </Box>
      </Box>
      <Typography align="center">
        {getButtonData(onFinish, cancelEdit, hasError, isTouched).map((element) => (
          <ButtonComponent
            sx={{
              m: 2,
            }}
            type={element.type}
            variant={element.variant}
            onClick={element.onClick}
            disabled={element.disabled}
            name={element.name}
          />
        ))}
      </Typography>
    </Container>
  );
};

SellerProductEntryForm.defaultProps = {
  symbol: CURRENCY,
};

SellerProductEntryForm.propTypes = {
  symbol: PropTypes.string,
  setState: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  updateProductSettingClicked: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
};

export default SellerProductEntryForm;
